import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";

type SubjectCreatedDescriptionDetails = {
  subject_name: string;
  id_type: string;
  id_value: string;
};

interface ISubjectCreatedDescriptionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectCreatedDescription = ({
  modifyDetailsJson,
}: ISubjectCreatedDescriptionProps) => {
  const { t } = useTranslation();

  const subjectAssignedDescriptionDetails: SubjectCreatedDescriptionDetails =
    useMemo(() => {
      return {
        subject_name:
          modifyDetailsJson.find((_) => _.key === "subject_name")?.value ?? "",
        id_type:
          modifyDetailsJson.find((_) => _.key === "id_type")?.value ?? "",
        id_value:
          modifyDetailsJson.find((_) => _.key === "id_value")?.value ?? "",
      } as SubjectCreatedDescriptionDetails;
    }, [modifyDetailsJson]);

  return (
    <>
      {t("HISTORY-TEMPLATES.policy-subject-created-description", {
        subject_name: subjectAssignedDescriptionDetails.subject_name,
        id_type: subjectAssignedDescriptionDetails.id_type,
        id_value: subjectAssignedDescriptionDetails.id_value,
      })}
    </>
  );
};
export default SubjectCreatedDescription;
